const BACKEND_ROUTES = {
  GET_ALL_FAVORITES: "Favorites/ListByUserId?pageSize=100&pageNumber=1",
  CREATE_TICKET: "Ticket/Create",
  TICKET_LIST: "Ticket/ListByUserId",
  TICKET_MESSAGES: "Message/ListByTicketId",
  SEND_MESSAGE: "Message/Create",
  GRADES: "Grade/List",
  MAJORS: "Major/List",
  PROFILE_VIEW: "Profile/View",
  PROFILE_UPDATE: "Profile/Update",
  PRODUCTS_SEARCH_BY_FILTER: "Product/SearchProductByFilters",
  PURCHASED_VIDEOS: "Product/GetUserPurchasedProducts",
  ORDERS_LIST: "Order/ListByUserId",
  ORDERS_ITEMS: "Order/View",
  GET_NAVBAR_MENUE: "Menu/GetNavbarMenu",
  GET_CART_DATA: "Cart/CartDetails",
  GET_VALIDATE_COUPON: "Discount/ValidateDiscountCode",
  POST_CREATE_ORDER: "Order/Create",
  GET_PAYMENT_LINK: "Payment/Payment",
  GET_WALLET_DETAILS: "Wallet/WalletDetails",
  POST_WALLET_LINK: "Wallet/ChargeWallet",
  GET_VERIFY_PAYMENT: "Wallet/VerifyWalletCharge",
  POST_ADD_FAVORITES: "Favorites/Create",
  POST_DEL_FAVORITES: "Favorites/Delete",
  GET_COMMENTS: `Comment/ListByProductId/`,
  POST_COMMENT: `Comment/Create/`,
  Get_ARVAN_VIDEOLINK: `Video/GetArvanSecureVideoLink/`,
  Get_SAMIN_VIDEOLINK: `Video/GetSaminSecureVideoLink/`,
  Get_APARAT_VIDEOLINK: `Video/GetAparatVideoLink/`,
  GET_APPEARANCE: "Appearance/GetAppearance",
  Get_SITEMAP: "Sitemap/GetSitemap",
  POST_COOPERATION: "Cooperation/Create",
  POST_EXAMFEATURE: "ExamFeature/Create",
  PUT_EXAMFEATURE: "ExamFeature/Update"
};

export default BACKEND_ROUTES;
